import {ApiUtil} from "../apiUtils";
import {GetProfileCEPayload} from "../../model/payload/profile.payload";
import {User} from "../../model/types/user";
import {
    AuthFromEmailOnBoardingResponseDTO,
    AuthResponseDTO, ChangePasswordAdminDTO,
    ChangePasswordDTO,
    EditPasswordDTO, SignupDTO
} from "../../model/dto/auth.dto";

export class AuthController {
    public static baseName = "auth"

    public static async signup(signupDTO: SignupDTO): Promise<AuthResponseDTO> {
        return await ApiUtil.makeRequest<AuthResponseDTO>(
            "post",
            AuthController.baseName+"/signup",
            false,
            signupDTO,
        );
    }
    public static async signin(email: string, password: string): Promise<AuthResponseDTO> {
        return await ApiUtil.makeRequest<AuthResponseDTO>(
            "post",
            AuthController.baseName+"/signin",
            false,
            {email: email, password: password},
        );
    }


    public static async auth(token: string): Promise<AuthResponseDTO> {
        return await ApiUtil.makeRequest<AuthResponseDTO>(
            "post",
            AuthController.baseName+"/tkn",
            false,
            {ceToken: token},
        );
    }

    public static async authFromEmailOnBoarding(token: string,onboarding: any): Promise<AuthFromEmailOnBoardingResponseDTO> {
        return await ApiUtil.makeRequest<AuthFromEmailOnBoardingResponseDTO>(
            "post",
            AuthController.baseName+"/fromEmailOnBoarding",
            false,
            {tkn: token,onboarding: onboarding},
        );
    }
    public static async passwordRecovery(email: string): Promise<{}> {
        return await ApiUtil.makeRequest<{}>(
            "post",
            AuthController.baseName+"/recoveryPassword",
            false,
            {email: email},
        );
    }
    public static async preSignup(email: string): Promise<{}> {
        return await ApiUtil.makeRequest<{}>(
            "post",
            AuthController.baseName+"/preSignup",
            false,
            {email: email},
        );
    }
    public static async checkCode(email: string,code:string,type: number): Promise<{}> {
        return await ApiUtil.makeRequest<{}>(
            "post",
            AuthController.baseName+"/checkCode",
            false,
            {email: email,code: code,type: type},
        );
    }
    public static async changePassword(changePassword: ChangePasswordDTO): Promise<{  }> {
        return await ApiUtil.makeRequest<{}>(
            "post",
            AuthController.baseName+"/changePassword",
            false,
            changePassword,
        );
    }


}
